import React from 'react'
import PropTypes from 'prop-types'
import { Root } from './Spinner.styles'

/**
 * The Spinner's component.
 */
const Spinner = props => {
  const { color, size } = props

  return <Root color={color} size={size} />
}

Spinner.defaultProps = {
  color: 'primary',
  size: 40
}
Spinner.propTypes = {
  color: PropTypes.oneOf(['primary', 'white']),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Spinner
